module.exports = __webpack_public_path__ + "fonts/nexa-light-webfont.8e16c92f.otf";